import classNames from 'classnames'
import { useMemo } from 'react'
import { formatNumber } from '../../libs/utils'

export default function InstalmentPlanSection(props) {
  const {
    instalment,
    price,
    statuses,
    instalment_amount: instalmentAmount,
    order_number: orderNumber,
    payment_amount: paymentAmount,
  } = props.instalment

  const memoizedInstalmentStatuses = useMemo(() => {
    if (instalment > 1 && !orderNumber) {
      const instalmentStatuses = []
      for (let index = 0; index < instalment; index += 1) {
        instalmentStatuses[index] = {
          period_num: index + 1,
          payment_amount: index === 0 ? paymentAmount : instalmentAmount,
          status: index === 0 ? 'processing' : 'init',
        }
      }
      return instalmentStatuses
    }
    return statuses
  }, [instalment, instalmentAmount, paymentAmount, statuses, orderNumber])

  return (
    <div className="mt-xxl">
      <p className="babu-text-paragraph-bold text-text600 my-xs">
        分期付款資訊
      </p>
      {Array.isArray(memoizedInstalmentStatuses)
        ? memoizedInstalmentStatuses.map((record, i) => (
            <p
              key={`instalment-status-${i}`}
              className={classNames(
                'my-xxs py-xs flex justify-between',
                record.status === 'success'
                  ? 'text-text600'
                  : record.status === 'init'
                  ? 'text-text500'
                  : 'text-primary',
              )}>
              <span>{`第 ${record.period_num} 期${
                record.status === 'success' ? '（已付款）' : ''
              }`}</span>
              <span>{`NT$${formatNumber(record.payment_amount)}`}</span>
            </p>
          ))
        : null}
      <hr className="text-text500 mt-0" />
      <p className="my-xxs py-xs flex justify-between text-text600">
        <span>總計付款金額</span>
        <b>{`NT$${formatNumber(price)}`}</b>
      </p>
      {orderNumber ? (
        <p className="my-xxs py-xs flex justify-between text-text600">
          <span>訂單編號</span>
          <b>{orderNumber}</b>
        </p>
      ) : null}
    </div>
  )
}
